import { ERentioFormField } from "../../components/components/Form";
import { CONFIG } from "../../config/app.config";
import { EEnvironment, EProduct } from "../../config/app.config.types";
import { getValue } from "../../redux/form/form.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
// The web apps whose sign-in forms (password and token) render the reCAPTCHA widget. An allowlist,
// so a consumer that cannot render it - the mobile app, or the insurance apps, which sign in on an
// API that takes no captcha - never gets a required field it cannot fill.
var PRODUCTS_WITH_SIGN_IN_CAPTCHA = [
    EProduct.Dashboard,
    EProduct.Backoffice,
    EProduct.Pay,
];
var CAPTCHA_FIELD = "captcha";
// Production only: the APIs ask no captcha on dev, stag and demo (isCaptchaEnforced there), so the
// forms show none either and testers sign in without solving one.
export var hasSignInCaptcha = function () {
    return CONFIG.ENVIRONMENT === EEnvironment.Prod &&
        !!CONFIG.CAPTCHA_KEY &&
        PRODUCTS_WITH_SIGN_IN_CAPTCHA.includes(CONFIG.PRODUCT);
};
// The captcha's part of a sign-in schema, decided once so the required list, the property and the
// field cannot drift apart. All three are empty when the app does not show a captcha.
export var getSignInCaptchaSchema = function (initialValues, defaultValues) {
    var _a, _b;
    if (!hasSignInCaptcha()) {
        return { required: [], properties: {}, uiSchema: {} };
    }
    return {
        required: [CAPTCHA_FIELD],
        properties: (_a = {},
            _a[CAPTCHA_FIELD] = {
                default: getValue(CAPTCHA_FIELD, initialValues, defaultValues),
            },
            _a),
        uiSchema: (_b = {},
            _b[CAPTCHA_FIELD] = {
                "ui:field": ERentioFormField.Captcha,
                title: getLocalizedText("system.captcha"),
            },
            _b),
    };
};
